import { format, isValid, parseISO } from 'date-fns';
import { DATE_FORMAT } from '../enums/dateEnums';

export const formatDate = (currentDate, dateFormat = null) => {
  if (currentDate == null) return 'No Date';
  const parsedDate = currentDate instanceof Date ? currentDate : parseISO(currentDate);
  if (isNaN(parsedDate.getTime()) && !isValid(parsedDate)) return 'Invalid Date';
  return format(parsedDate, dateFormat ?? DATE_FORMAT);
};

export function formatIsoDate(isoDateStr, options = {}) {
  if (!isoDateStr) return '';

  const date = new Date(isoDateStr);

  const defaultOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  return new Intl.DateTimeFormat('en-US', { ...defaultOptions, ...options }).format(date);
}